import { SET_ALERT_INFO, REMOVE_ALERT } from './alert-info.action';
import { Alert } from './alertType';

const initialvalues: Alert[] = [];

export const alertReducer = (
  state = initialvalues,
  action: { type: string; payload: Alert | number }
) => {
  switch (action.type) {
    case SET_ALERT_INFO: {
      const newState = [...state, action.payload];
      return newState;
    }

    case REMOVE_ALERT: {
      const newState = state.filter((_, index) => index !== action.payload);
      return newState;
    }

    default:
      return state;
  }
};

export default alertReducer;
